export default __webpack_public_path__ + "static/media/NotoSans-Light.f01baf9d.woff2";